import styled from 'styled-components';

export interface ProgressBarProps {
  color: string;
  percentage: number;
}

export interface ContainerProps {
  equalVerticalSpacing?: boolean;
  fixedHeight?: number;
}

export const Container = styled.div<ContainerProps>`
  display: flex;
  flex-direction: column;
  ${(props) =>
    props.equalVerticalSpacing
      ? 'justify-content: space-around;'
      : 'gap: 14px;'}
  width: 100%;
  height: ${(props) => {
    if (props.fixedHeight) {
      return `${props.fixedHeight}px`;
    }
    return props.equalVerticalSpacing ? '100%' : 'auto';
  }};
  ${(props) =>
    props.fixedHeight &&
    `
    overflow-y: auto;
    overflow-x: hidden;
  `}
`;

export const BarContainer = styled.div`
  display: flex;
  align-items: center;
  width: 100%;
  gap: 8px;
`;

export const Title = styled.div<{ wrapText?: boolean }>`
  ${(props) => props.theme?.mergedTypography?.fontSmallRegular};
  color: ${(props) => props.theme?.colors?.textSecondary};
  white-space: normal;
  word-wrap: break-word;
  flex-shrink: 0;
  word-break: break-word;
  line-height: 1.2;
  width: fit-content;
  max-width: 250px;

  @media (max-width: 768px) {
    max-width: 120px;
    font-size: 12px;
  }

  @media (max-width: 1024px) and (min-width: 769px) {
    max-width: 180px;
  }
`;

export const ProgressBar = styled.div<ProgressBarProps>`
  height: 8px;
  width: ${(props) => props.percentage}%;
  background-color: ${(props) => props.color};
  border-radius: 0px 4px 4px 0px;
  transition: width 0.5s ease-in-out;
  min-width: 0;
  max-width: 200px;
  position: relative;

  &::before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    width: 200px;
    height: 100%;
    background-color: ${(props) => props.theme?.colors?.border || '#e0e0e0'};
    border-radius: 4px;
    z-index: -1;
  }

  @media (max-width: 768px) {
    max-width: 100px;

    &::before {
      width: 100px;
    }
  }

  @media (max-width: 1024px) and (min-width: 769px) {
    max-width: 150px;

    &::before {
      width: 150px;
    }
  }
`;

export const Percentage = styled.div`
  ${(props) => props.theme?.mergedTypography?.fontXXsmallBold};
  color: ${(props) => props.theme?.colors?.textSecondary};
  white-space: nowrap;
  flex-shrink: 0;

  @media (max-width: 768px) {
    font-size: 10px;
  }
`;

export const LoaderWrapper = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 100%;
`;
